/** Base URL for order links (e.g. /volne-terminy). */
export const ORDER_TERMS_BASE = '/volne-terminy'

/** Href for "Pridať voliteľné moduly" button and modules section anchor. */
export const MODULES_HREF = '#moduly'
